export const teams = [
  {
    id: 1,
    name: "Worlidge / Flanagan",
    players: ["Worlidge", "Flanagan"],
    images: ["worlidge.jpeg", "flanagan.jpeg"],
    rankings: [2, 17],
    odds: "+250",
    handicap: -6,
  },
  {
    id: 2,
    name: "O'Brien / Bajzik",
    players: ["O'Brien", "Bajzik"],
    images: ["o'brien.jpeg", "bajzik.jpeg"],
    odds: "+300",
    rankings: [13, 6],
    handicap: -6,
  },
  {
    id: 3,
    name: "Cancilla / Opie",
    players: ["Cancilla", "Opie"],
    images: ["cancilla.jpeg", "opie.jpeg"],
    odds: "+350",
    rankings: [3, 16],
    handicap: -6,
  },
  {
    id: 4,
    name: "Cornford / Robertson",
    players: ["Cornford", "Robertson"],
    images: ["cornford.jpeg", "robertson.jpeg"],
    odds: "+400",
    rankings: [12, 7],
    handicap: -6,
  },
  {
    id: 5,
    name: "Schwehr / Campbell",
    players: ["Schwehr", "Campbell"],
    images: ["schwehr.jpeg", "campbell.jpeg"],
    odds: "+450",
    rankings: [1, 18],
    handicap: -6,
  },
  {
    id: 6,
    name: "Fobert / Cochrane",
    players: ["Fobert", "Cochrane"],
    images: ["fobert.jpeg", "cochrane.jpeg"],
    odds: "+500",
    rankings: [4, 15],
    handicap: -6,
  },
  {
    id: 7,
    name: "Petrie / Atkinson",
    players: ["Petrie", "Atkinson"],
    images: ["petrie.jpeg", "atkinson.jpeg"],
    odds: "+550",
    rankings: [8, 11],
    handicap: -6,
  },
  {
    id: 8,
    name: "Aaron Campbell / Stanisz",
    players: ["Aaron Campbell", "Stanisz"],
    images: ["aaron_campbell.jpeg", "stanisz.jpeg"],
    odds: "+600",
    rankings: [5, 14],
    handicap: -6,
  },
  {
    id: 9,
    name: "R. Opie / Myers",
    players: ["R. Opie", "Myers"],
    images: ["r opie.jpeg", "myers.jpeg"],
    odds: "+650",
    rankings: [9, 10],
    handicap: -6,
  },
  {
    id: 10,
    name: "Mason / Ellis",
    players: ["Mason", "Ellis"],
    images: ["mason.jpeg", "ellis.jpeg"],
    odds: "+700",
    rankings: [0, 0],
    handicap: -6,
  },
];
